// extracted by mini-css-extract-plugin
export default {"your_rd":"Ku","title":"Lu","subtitle":"Mu","rd_bio_wrapper":"Nu","rd_text_mobile":"Ou","rd_bio":"Pu","img":"Qu","rd_info":"Ru","rd_name":"Su","rd_stat":"Tu","rd_text":"Uu","btn_mobile":"Vu"};
    if(module.hot) {
      // 1713912563374
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  